<template>
  <div id="liveplay">
    <!--视频位置-->
    <div class="video"></div>
    <!--播放组件-->
    <nav>
      <a href=""><img src="../../assets/icon/liveplay_icon_classlist.png" alt="">课程列表</a>
      <a href=""><img src="../../assets/icon/liveplay_icon_previous.png" alt=""></a>
      <a href=""><img src="../../assets/icon/liveplay_icon_play.png" alt=""></a>
      <a href=""><img src="../../assets/icon/liveplay_icon_next.png" alt=""></a>
      <a href=""><img src="../../assets/icon/liveplay_icon_pdfopen.png" alt="">缓存课件</a>
    </nav>
    <!--直播提示条-->
    <div class="cue">
      <h6>今日直播</h6>
      <a href="">去观看></a>
    </div>
    <!--课程列表-->
    <h3 class="course-title">
      课程列表
    </h3>
    <div class="course-list">
      <dl class="cc">
        <dt>
          <h5>01 | 领学班</h5>
          <span class="arrow"></span>
        </dt>
        <dd>
          <a href="">
            <div class="top">
              <div class="left">
                <h6>领学班</h6>
                <p>2018-06-14</p>
              </div>
              <div class="right">
                今日直播
              </div>
            </div>
            <div class="progress">
              <div class="bar"></div>
              <span>观看0%</span>
            </div>
          </a>
          <a href="">
            <h6>领学班</h6>
            <p>2018-06-14</p>
          </a>
          <a href="">
            <h6>领学班</h6>
            <p>2018-06-14</p>
          </a>
        </dd>
      </dl>
      <dl class="cc">
        <dt class="active">
          <h5>02 | 领学班</h5>
          <span class="arrow"></span>
        </dt>
        <dd>
          <a href="">
            <div class="top">
              <div class="left">
                <h6>领学班</h6>
                <p>2018-06-14</p>
              </div>
              <div class="right">
                <span class="active">今日直播</span>
              </div>
            </div>
            <div class="progress">
              <div class="bar"></div>
              <span>观看0%</span>
            </div>
          </a>
          <a href="">
            <div class="top">
              <div class="left">
                <h6>领学班</h6>
                <p>2018-06-14</p>
              </div>
              <div class="right">
                <span>未直播</span>
              </div>
            </div>
            <div class="progress">
              <div class="bar"></div>
              <span>观看0%</span>
            </div>
          </a>
          <a href="">
            <div class="top">
              <div class="left">
                <h6>领学班</h6>
                <p>2018-06-14</p>
              </div>
              <div class="right">
                <span>未直播</span>
              </div>
            </div>
            <div class="progress">
              <div class="bar"></div>
              <span>观看0%</span>
            </div>
          </a>
        </dd>
      </dl>
      <dl class="cc">
        <dt class="active">
          <h5>03 | 领学班</h5>
          <span class="arrow"></span>
        </dt>
        <dd>
          <a href="">
            <div class="top">
              <div class="left">
                <h6>领学班</h6>
                <p>2018-06-14</p>
              </div>
              <div class="right">
                <span>未直播</span>
              </div>
            </div>
            <div class="progress">
              <div class="bar"></div>
              <span>观看0%</span>
            </div>
          </a>
          <a href="">
            <div class="top">
              <div class="left">
                <h6>领学班</h6>
                <p>2018-06-14</p>
              </div>
              <div class="right">
                <span>未直播</span>
              </div>
            </div>
            <div class="progress">
              <div class="bar"></div>
              <span>观看0%</span>
            </div>
          </a>
          <a href="">
            <div class="top">
              <div class="left">
                <h6>领学班</h6>
                <p>2018-06-14</p>
              </div>
              <div class="right">
                <span>未直播</span>
              </div>
            </div>
            <div class="progress">
              <div class="bar"></div>
              <span>观看0%</span>
            </div>
          </a>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LivePlay'
}
</script>

<style scoped lang="stylus">
#liveplay
  .video
    width: 7.5rem
    height: 4.24rem
    background: url(../../assets/img/liveplay_bg_video.png) no-repeat center
    -webkit-background-size: 100%
    background-size: 100%
  nav
    display: flex
    justify-content: space-around
    align-items: center
    background-color: #FAFAFA
    padding: .24rem 0
    a
      display: block
      text-align: center
      img
        display: block
        width: 100%
        height: 100%
      &:nth-of-type(1), &:nth-of-type(5)
        width: 1rem
        height: 1rem
        font-size: .22rem
        color: #999
        img
          width: .36rem
          height: .42rem
          margin: .14rem auto
      &:nth-of-type(2), &:nth-of-type(4)
        width: .44rem
        height: .4rem
      &:nth-of-type(3)
        width: 1.28rem
        height: 1.28rem
  .cue
    display: flex
    justify-content: space-between
    align-items: center
    width: 6.7rem
    height: .76rem
    background: linear-gradient( to right, #FA8E58, #FFEC9D)
    padding: 0 .2rem
    margin: .32rem auto
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    -webkit-border-radius: .08rem
    -moz-border-radius: .08rem
    border-radius: .08rem
    h6
      font-size: .3rem
      color: #fff
    a
      display: block
      width: 1.44rem
      height: .52rem
      line-height: .52rem
      background-color: #fff
      font-size: .28rem
      color: #FF7052
      text-align: center
      -webkit-border-radius: .26rem
      -moz-border-radius: .26rem
      border-radius: .26rem
  h3.course-title
    padding: 0 .4rem
    margin: .32rem auto
    font-size: .36rem
    color: #050505
    font-weight: 600
  .course-list
    padding: 0 .4rem
    dl
      dt
        display: flex
        justify-content: space-between
        align-items: center
        width: 6.7rem
        height: .8rem
        padding: 0 .3rem
        margin-top: .2rem
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        -webkit-box-shadow: 0 0.04rem 0.08rem 0 rgba(227,231,230,0.74);
        -moz-box-shadow: 0 0.04rem 0.08rem 0 rgba(227,231,230,0.74);
        box-shadow: 0 0.04rem 0.08rem 0 rgba(227,231,230,0.74);
        -webkit-border-radius: .05rem
        -moz-border-radius: .05rem
        border-radius: .05rem
        h5
          font-size: .3rem
          color: #050505
        span.arrow
          &::before
            content: ""
            position: relative
            top: -.04rem
            right: .1rem
            display: inline-block
            width: .1rem
            height: .1rem
            border-left: .03rem solid #666
            border-bottom: .03rem solid #666
            -webkit-transform: rotate(-45deg)
            -moz-transform: rotate(-45deg)
            -ms-transform: rotate(-45deg)
            -o-transform: rotate(-45deg)
            transform: rotate(-45deg)
        &.active
          -webkit-box-shadow: none
          -moz-box-shadow: none
          box-shadow: none
          span.arrow
            &::before
              top: 0
              -webkit-transform: rotate(135deg)
              -moz-transform: rotate(135deg)
              -ms-transform: rotate(135deg)
              -o-transform: rotate(135deg)
              transform: rotate(135deg)
        &.active + dd
          display: block
      dd
        display: none
        width: 6.7rem
        background-color: #FAFAFA
        padding: 0 .2rem
        margin-top: .2rem
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        -webkit-border-radius: .2rem
        -moz-border-radius: .2rem
        border-radius: .2rem
        a
          display: block
          width: 100%
          height: 1.54rem
          border-bottom: .02rem solid #E1E1E1
          padding: .22rem 0
          -webkit-box-sizing: border-box
          -moz-box-sizing: border-box
          box-sizing: border-box
          &:last-child
            border: none
          .top
            display: flex
            justify-content: space-between
            align-items: center
            .left
              display: block
              width: 80%
              height: .68rem
              h6
                font-size: .3rem
                color: #333
              p
                font-size: .22rem
                color: #999
            .right
              display: block
              width: 20%
              span
                font-size: .22rem
                color: #8A88A1
                &.active
                  color: #FF7052
          .progress
            display: flex
            justify-content: space-between
            align-items: center
            margin-top: .2rem
            .bar
              width: 4.7rem
              height: .12rem
              background-color: #E5E7EB
              -webkit-border-radius: .06rem
              -moz-border-radius: .06rem
              border-radius: .06rem
            span
              display: inline-block
              width: .96rem
              height: .26rem
              line-height: .26rem
              font-size: .18rem
              color: #8A88A1
              text-align: left
</style>



// WEBPACK FOOTER //
// src/components/play/LivePlay.vue